import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class Form1065M2Service {
  private defaultsSaveUrl: string;

  constructor(private http: HttpClient,) {
    this.defaultsSaveUrl = "/saveJsonObject?action_code=to8rt3";
   }

  saveSchdM2(base_url: string, _data: any, Details: any, globalService: any, rowData: any = {}, filterParams: any = {}): Observable<any> {
    const workspaceFilterParams = (globalService?.workspaceFactory?.activeScreen?.filters)
      ? globalService.workspaceFactory.activeScreen.filters.getFilterParams()
      : {};
    
    const allFilterParams = _.merge({}, workspaceFilterParams, filterParams);
    
    const jsonObj = JSON.stringify(Details);
    const jsonSettings = JSON.stringify(_data);

    let params = _.merge({}, globalService.globalParams, allFilterParams);
    params = _.extend({ clob_data: jsonObj }, params);
    params = _.extend({ clob_settings: jsonSettings }, params);
    params.process_name = "scdM2_1065_save";

    params.tax_year = rowData.TAX_YEAR || filterParams.tax_year || globalService.globalParams?.tax_year;
    params.scenario = rowData.SCENARIO || filterParams.scenario || globalService.globalParams?.scenario;
    params.jcd_key = rowData.JCD_KEY || filterParams.jcd_key || globalService.globalParams?.jcd_key;
    params.scenarioCode = rowData.SCENARIO_CODE || filterParams.scenarioCode || rowData.SCENARIO || filterParams.scenario || globalService.globalParams?.scenario;
    params.is_issue_key_enabled = rowData.IS_ISSUE_KEY_ENABLED || filterParams.is_issue_key_enabled || 'N';

    const urlParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== null && params[key] !== undefined) {
        urlParams.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });
    
    return this.http.post(base_url + this.defaultsSaveUrl, urlParams.toString(), { headers }).pipe(
      map((response: any) => {
        return response;
      })
    );
  }

  // Parity alias for AngularJS partnershipMtwoFactory.saveM2Amounts
  saveM2Amounts(base_url: string, _data: any, Details: any, globalService: any, rowData: any, filterParams: any): Observable<any> {
    return this.saveSchdM2(base_url, _data, Details, globalService, rowData, filterParams);
  }
}